import { useCallback, useEffect, useRef, useState } from 'react';
import ApprovalHistoryReport from '../ApprovalHistoryandComplianceReport'
import { useDispatch, useSelector } from 'react-redux';
import { getRegionDropDown } from 'Store/Organization/Region/RegionAction';
import { getMarketDropDown } from 'Store/Organization/Market/MarketAction';
import { getComplianceReportGridData, getComplianceReportTableExcel, setComplianceReportFilterData, setComplianceReportGridData, setComplianceReportTableExcel } from 'Store/OrderManagement/ComplainceReport/ComplainceReportAction';
import useLocationDropDowns from '../ApprovalManagement.hook';
import { fetchGridData, handleChange, handleChangeSearchedCostCenter, onDateChange, searchCostCenter } from '../ApprovalFunctions';
import { base64ToArrayBuffer, saveByteArray } from 'utils';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getCostCenterByMarket } from 'Store/Organization/CostCenterByMarket/CostCenterByMarketAction';

const defaultDateRange = [new Date(moment().subtract(3, "months").toDate()), new Date(moment().toDate())]

const ApprovalComplianceContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let complianceReportFilterDataTemp = useRef<any>(null)
  const [costCentersBySearchList, setCostCentersBySearchList] = useState([])
  
  ///selectors
  const {
    regionDropDown,
    marketDropDown,
    getUserDetails,
    complianceReportGridData,
    complianceReportTableExcel,
    complianceReportFilterData,
    costCenterBySearchDropDownList,
    costCenterByMarketDropDownList,
    isMyOrdersGridLoading
  }: any = useSelector((state: any) => ({
    regionDropDown: state?.RegionDropDownReducer?.regionDropDown,
    marketDropDown: state?.MarketDropDownReducer?.marketDropDown,
    getUserDetails: state.UserProfile.getUserDetails,
    complianceReportGridData: state.ComplianceReportReducer.complianceReportGridData,
    complianceReportTableExcel: state.ComplianceReportReducer.complianceReportTableExcel,
    complianceReportFilterData: state.ComplianceReportReducer.complianceReportFilterData,
    costCenterBySearchDropDownList: state.CostCentersReducer.costCenterBySearchDropDownList,
    costCenterByMarketDropDownList: state.CostCenterByMarketReducers.costCenterByMarket,
    isMyOrdersGridLoading: state.TransferGridReducer.isMyOrdersGridLoading,
  }))

  const [showComplianceGrid, setShowcomplianceGrid] = useState<any>(complianceReportGridData?.data?.length > 0);
  const [pagesCount, setPagesCount] = useState<number>(complianceReportFilterData?.pagesCount ?? 0)
  const [pagingData, setPagingData] = useState<any>(complianceReportFilterData?.paginationData)
  const [sortingData, setSortingData] = useState<any>(complianceReportFilterData?.sortData)

  const [
    regionDropDownList,
    marketDropDownList,
    costCentersByMarketList
  ] = useLocationDropDowns({
    regionDropDown,
    marketDropDown,
    costCenterByMarketDropDownList,
    getRegionDropDown,
    getMarketDropDown,
    getCostCenterByMarket,
    complianceReportFilterData,
    isApprovalHistory : false
  })

  useEffect(() => {
    if(complianceReportFilterData){
      complianceReportFilterDataTemp.current = complianceReportFilterData
    }
  },[complianceReportFilterData?.searchedCostCenter?.value])

  useEffect(() => {
    if (complianceReportGridData?.totalRecords && complianceReportFilterData?.paginationData?.pageSize) {
      let pageSize = complianceReportFilterData?.paginationData?.pageSize ?? 0;
      let tempPageCount = complianceReportGridData?.totalRecords > pageSize ? Math.ceil(complianceReportGridData?.totalRecords / pageSize - 1) : 0
      setPagesCount(tempPageCount)
      dispatch(setComplianceReportFilterData({ ...complianceReportFilterData, pagesCount: tempPageCount }))
    }
  }, [complianceReportGridData?.totalRecords, complianceReportFilterData?.paginationData?.pageSize])

  useEffect(() => {
    if (costCenterBySearchDropDownList?.length) {
      const branchTypeDropdownListTemp = costCenterBySearchDropDownList?.map((item: any) => ({ ...item, label: item?.text }));
      setCostCentersBySearchList(branchTypeDropdownListTemp);
    }
  }, [costCenterBySearchDropDownList])

  useEffect(()=>{
    if(complianceReportTableExcel){
      const byteArray = base64ToArrayBuffer(complianceReportTableExcel)
      saveByteArray('Compliance_Report_List', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      dispatch(setComplianceReportTableExcel(null))
  }
  }, [complianceReportTableExcel])

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data
      setPagingData(paginationData)
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortingData(data)
    }
  }, [])

  useEffect(() => {
    dispatch(setComplianceReportFilterData({ ...complianceReportFilterData, paginationData: pagingData, sortData: sortingData}))
  }, [pagingData, sortingData])

  useEffect(() => {
    dispatch(getRegionDropDown());
    dispatch(setComplianceReportGridData(null))
  }, [])

  useEffect(() => {
    const costCenterValue = complianceReportFilterData?.searchedCostCenter?.value ? {type: "CostCenter" , id: complianceReportFilterData?.searchedCostCenter?.value} : getLocationFilter()
  if(costCenterValue){
    fetchGridData(costCenterValue, complianceReportFilterData?.dateRange ?? defaultDateRange, complianceReportFilterData?.paginationData, complianceReportFilterData?.sortData, getUserDetails?.emailId, getComplianceReportGridData, dispatch, false)
  }
  }, [complianceReportFilterData?.paginationData, complianceReportFilterData?.sortData])

  const handleDropDownChange = (value: any, name: string) => {
    handleChange(value, name, setComplianceReportFilterData, complianceReportFilterData, setShowcomplianceGrid, dispatch)
  }

  const onSearchCostCenter = (value: any) => {
    handleChangeSearchedCostCenter(value, setComplianceReportFilterData, {...complianceReportFilterData, dateRange: complianceReportFilterData?.dateRange ?? defaultDateRange}, getUserDetails?.emailId, getComplianceReportGridData, setShowcomplianceGrid, dispatch, false)
  }

  const searchCostCenterFunction = (value: any, action: any) => {
    searchCostCenter(value, action, dispatch)
  }

  const onDateRangeChange = (date: any) => {
    const costCenterValue = complianceReportFilterData?.searchedCostCenter?.value ? {type: "CostCenter" , id: complianceReportFilterData?.searchedCostCenter?.value} : getLocationFilter()
    onDateChange(date, setComplianceReportFilterData, complianceReportFilterData, getUserDetails?.emailId, getComplianceReportGridData, dispatch, false, costCenterValue)
  }

  const onModifiedDateClicked = (row: any) => {
      navigate(`complianceauditreport/${row?.rowData?.entityId}/${row?.rowData?.entityType}/${moment(row?.rowData?.modifiedDate).format("YYYY-MM-DD")}`)
  }

  const columns = [
    {
      key: "modifiedDate",
      title: "Modified Date",
      width: 100,
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(e: any) => {
              e?.preventDefault()
              onModifiedDateClicked(row);
            }}
            className="order-link-id"
          >
            {row.rowData.modifiedDate
              ? moment(row.rowData.modifiedDate).format("MM/DD/YYYY")
              : ""}
          </a>
        );
      },
    },
    {
      key: "modifiedBy",
      title: "Modified By",
      width: 270
    },
    {
      key: "costCenter",
      title: "Cost Center",
      width: 270
    },
    {
      key: "region",
      title: "Region",
      width: 250
    },
    {
      key: "market",
      title: "Market",
      width: 250
    }
  ];

  const getLocationFilter = () => {
    if (complianceReportFilterData?.costCenter?.value) {
      return { type: "CostCenter", id: complianceReportFilterData?.costCenter?.value }
    } else if (complianceReportFilterData?.market?.value) {
      return { type: "Market", id: complianceReportFilterData?.market?.value }
    } else if (complianceReportFilterData?.region?.value) {
      return { type: "Region", id: complianceReportFilterData?.region?.value }
    } else if (complianceReportFilterData?.superRegion?.value) {
      return { type: "SuperRegion", id: complianceReportFilterData?.superRegion?.value }
    } else if (complianceReportFilterData?.division?.value) {
      return { type: "Division", id: complianceReportFilterData?.division?.value }
    }
  }

  const search = () => {
    const costCenterValue = getLocationFilter()
    if(costCenterValue){
      fetchGridData(costCenterValue, complianceReportFilterData?.dateRange ?? defaultDateRange, complianceReportFilterData?.paginationData, complianceReportFilterData?.sortData, getUserDetails?.emailId, getComplianceReportGridData, dispatch, false)
      dispatch(setComplianceReportFilterData({ ...complianceReportFilterData, searchedCostCenter: "" }))
      setShowcomplianceGrid(true)
    }
  }

  const onExportExcel = (e: any) => {    
    e.preventDefault();
    e.stopPropagation();
    const costCenterValue = complianceReportFilterData?.searchedCostCenter?.value ? {type: "CostCenter" , id: complianceReportFilterData?.searchedCostCenter?.value} : getLocationFilter()
    fetchGridData(costCenterValue, complianceReportFilterData?.dateRange ?? defaultDateRange, complianceReportFilterData?.paginationData, complianceReportFilterData?.sortData, getUserDetails?.emailId, getComplianceReportTableExcel, dispatch, false)
  }

  const onClearClick = () => {
    setShowcomplianceGrid(false)
    dispatch(setComplianceReportFilterData({ ...complianceReportFilterData, region: "", market: "", costCenter: "", searchedCostCenter: "", dateRange: defaultDateRange }))
  }
  
  return (
    <ApprovalHistoryReport
      regionDropDownList={regionDropDownList}
      selectedRegion={complianceReportFilterData?.region}
      marketDropDownList={marketDropDownList}
      selectedMarket={complianceReportFilterData?.market}
      handleChange={handleDropDownChange}
      selectedCostCenter={complianceReportFilterData?.costCenter}
      fetchAction={fetchAction}
      columns={columns}
      showGrid={showComplianceGrid}
      pagesCount={pagesCount}
      dateRange={complianceReportFilterData?.dateRange ?? defaultDateRange}
      costCentersBySearchList = {costCentersBySearchList}
      handleChangeSearchedCostCenter = {onSearchCostCenter}
      searchCostCenter = {searchCostCenterFunction}
      onDateChange = {onDateRangeChange}
      search = {search}
      getLocationFilter = {getLocationFilter}
      onExportExcel={onExportExcel} 
      gridData = {complianceReportGridData?.data}
      serverTotal={complianceReportGridData?.totalRecords}
      paginationData={complianceReportFilterData?.paginationData}
      selectedSearchedCostCenter={complianceReportFilterData?.searchedCostCenter}
      isApprovalHistory = {false}
      costCentersByMarketList = {costCentersByMarketList}
      onClearClick = {onClearClick}
      isMyOrdersGridLoading = {isMyOrdersGridLoading}
    />
  )
}

export default ApprovalComplianceContainer